import { apiClient } from "../apiClient"
import { env as ENV } from "../env"
var intId = 0
const path = document.location.pathname.replace('.html', '')
var appBuild = ''

// 定义playAudio方法，给app内嵌时调用
window.graft.playAudio = function(e){
    if (e.errorCode == 0 && typeof e.data == 'object') {
        let audio_field = document.getElementById(e.data.audio_id)
        if (audio_field) {
            let current = currentTime({
                currentTime: e.data.audio_position/1000,
                duration: e.data.duration/1000
            })
            audio_field.querySelector(".current-time").innerHTML = current.time
            audio_field.querySelector(".current").style.width = current.width
            if (e.data.audio_status == '1') { // 播放中
                audio_field.querySelector(".play").style.display = "none"
                audio_field.querySelector(".pause").style.display = "block"
            } else {
                audio_field.querySelector(".play").style.display = "block"
                audio_field.querySelector(".pause").style.display = "none"
            }
            sessionStorage.setItem(e.data.audio_id, JSON.stringify(e.data))
        }
    }
}

const getAppBuild = async () => {
    return new Promise(function (resolve, reject) {
        if (appBuild) {
            resolve()
        } else {
            window.graft.app({
                functionName: "onGetUserInfo",
                callBack: (e) => {
                    if (e.data && typeof e.data == 'object') {
                        appBuild = e.data.build || ''
                    }
                    resolve()
                }
            })
            setTimeout(() => {
                resolve()
            }, 3000)
        }
    })
}

export const get_audio_poster = function (than, env, channel, index) {
    let audio_field = document.createElement("div")
    audio_field.className = "audio_field"
    audio_field.setAttribute("_url", than.getAttribute("_url"))

    const title = than.getAttribute("_name") || than.getAttribute("data-name")
    const src = than.getAttribute("_url") || than.getAttribute("data-url") || than.getAttribute("src")
    const duration = than.getAttribute("_duration") || than.getAttribute("data-duration")
    
    let audio_id = encodeURIComponent(path.replace(/\//g, "") + src.substring(src.lastIndexOf("/") + 1).replace(".mp3", "") + index)
    audio_field.id = audio_id

    const audioInfo = sessionStorage.getItem(audio_id)
    const audioObj = audioInfo && audioInfo.length > 2 && typeof JSON.parse(audioInfo) == 'object' ? JSON.parse(audioInfo) : {
        audio_status: 0, // 音频播放状态
        audio_position: 0, // 当前播放时长
    }
    audio_field.innerHTML = `
        <div class="audio_cover">
            <div class="play" style="display:${audioObj.audio_status == '0'? 'block' : 'none'}"></div>
            <div class="pause" style="display: ${audioObj.audio_status == '0'? 'none' : 'block'}"></div>
            <audio id=${new Date().getTime() + '_' + intId++}></audio>
        </div>
        <div class="audio_content">
            <div class="title">${title}</div>
            <div class="content_btm">

                <div class="progress">
                    <div class="current" style="width: 0;"></div>
                </div>
                <div class="time"><span class="current-time">${currentTime({
                    currentTime: audioObj.audio_position/1000,
                    duration: audioObj.duration/1000
                }).time}</span>/${audioObj.duration ? formateTimes(audioObj.duration/1000) : duration}</div>
            </div>
        </div>`
    const cur_audio = audio_field.querySelector("audio")
    function playFun(){
        let current = currentTime(cur_audio)
        audio_field.querySelector(".current-time").innerHTML = current.time
        audio_field.querySelector(".current").style.width = current.width
    }

    function pauseFun() {
        showPlay(audio_field, cur_audio)
    }
    let ifGetShow = false

    audio_field.onclick = async () => {
        await getAppBuild()

        if (!ifGetShow) {
            let obj = await getShowAudio(src, env, channel)
            let new_src = obj.src
            if (!new_src) return
            audio_field.querySelector('audio').src = new_src
            ifGetShow = true
        }

        var father = audio_field.parentNode
        while (father.className != "html-from-editor") {
            father = father.parentNode
        }
        father.querySelectorAll(".html-from-editor video").forEach(ele => {
            ele.pause()
        })

        father.querySelectorAll(".html-from-editor .audio_field").forEach(ele => {
            if (ele.querySelector("audio").id !== cur_audio.id) {
                showPlay(ele, ele.querySelector("audio"), 'audio')
            }
        })
        let audioInfo = sessionStorage.getItem(audio_id)
        let audio_status = audioInfo && audioInfo.length > 2 && typeof JSON.parse(audioInfo) == 'object' ? (JSON.parse(audioInfo).audio_status == '0' ? 1 : 0) : 1
        if (appBuild > '62310171') {
            window.graft.app({
                functionName: "playAudio",
                functionParams: {
                    audio_id: audio_id,
                    audio_url: src,
                    audio_status: audio_status
                },
                callBack: (e) => {
                    if (e.errorCode == 0 && typeof e.data == 'object') {
                        let current = currentTime({
                            currentTime: e.data.audio_position/1000,
                            duration: e.data.duration/1000
                        })
                        audio_field.querySelector(".current-time").innerHTML = current.time
                        audio_field.querySelector(".current").style.width = current.width
    
                        if (e.data.audio_status == '1') { // 播放中
                            audio_field.querySelector(".play").style.display = "none"
                            audio_field.querySelector(".pause").style.display = "block"
                        } else {
                            audio_field.querySelector(".play").style.display = "block"
                            audio_field.querySelector(".pause").style.display = "none"
                        }
                        sessionStorage.setItem(audio_id, JSON.stringify(e.data))
                    }
                },
                webFun: () => {
                    if (cur_audio.paused) {
                        showPause(audio_field, cur_audio)
                        cur_audio.addEventListener('timeupdate', playFun)
                        cur_audio.addEventListener('ended', pauseFun)
                    } else {
                        showPlay(audio_field, cur_audio)
                        cur_audio.removeEventListener('timeupdate', playFun)
                        cur_audio.removeEventListener('ended', pauseFun)
                    }
                }
            })
        } else {
            if (cur_audio.paused) {
                showPause(audio_field, cur_audio)
                cur_audio.addEventListener('timeupdate', playFun)
                cur_audio.addEventListener('ended', pauseFun)
            } else {
                showPlay(audio_field, cur_audio)
                cur_audio.removeEventListener('timeupdate', playFun)
                cur_audio.removeEventListener('ended', pauseFun)
            }
        }
        
    }
    than.parentNode.replaceChild(audio_field, than)
}
// 暂停
export const showPlay = async function(than, cur_audio, type) {
    let audio_field = than
    cur_audio.pause()
    audio_field.querySelector(".play").style.display = "block"
    audio_field.querySelector(".pause").style.display = "none"


    await getAppBuild()
    if (appBuild > '62310171') {
        // 如果再app里，更新音频存储状态
        const audioInfo = sessionStorage.getItem(audio_field.id)
        if (audioInfo && audioInfo.length > 2 && typeof JSON.parse(audioInfo) == 'object' ) {
            let obj = JSON.parse(audioInfo)
            obj = {...obj, audio_status: 0}
            sessionStorage.setItem(audio_field.id, JSON.stringify(obj))
        }

        // 在video.js里调用，当视频播放时，暂停音频
        if (type == "video") {
            window.graft.app({
                functionName: "playAudio",
                functionParams: {
                    audio_id: audio_field.id,
                    audio_url: cur_audio.src,
                    audio_status: 0
                }
            })
        } else if(type == 'audio' && (ENV.isModianAndroid() || ENV.isModianIos() || ENV.isModianIosNew())) {
            // 如果是其他音频播放，迫使暂停，进度条回到起点
            audio_field.querySelector(".current").style.width = "0"
        }
    }
}
// 播放
const showPause = function(than, cur_audio) {
    cur_audio.play()
    than.querySelector(".play").style.display = "none"
    than.querySelector(".pause").style.display = "block"
}
// 当前时间
const currentTime = function (cur_audio) {
    var curTime = Math.floor(cur_audio.currentTime) // 当前播放时间
    var totalTime = cur_audio.duration //总时长
    return {
        time: formateTimes(curTime),
        width: (cur_audio.currentTime / totalTime * 10000).toFixed() / 100 + '%'
    }
}

const formateNums = function (nums) {
    if (Number(nums) <= 9) {
        return '0' + nums
    } else {
        return nums
    }
}

const getShowAudio = async (src, env, channel) => {
    if (!src) return
    let new_src = ""
    let duration = 0
    try {
        const res = await apiClient({
            env: env
        })({
            url: "/apis/upload/get_address",
            method: "get",
            props: {
                keys: src,
                file_type: 'music',
                channel: channel ? channel : 'project'
            },
        })
        if (res.status == 0) {
            new_src = res.data.url ? res.data.url : ''
            duration = res.data.duration ? res.data.duration : 0
        }
        return {
            src: new_src,
            duration: duration
        }
    } catch (e) {
        return {
            src: src,
            duration: duration
        }
    }
}

const formateTimes = function(times) {
    times = Math.floor(times)
    var minutes = '00' // 分
    var seconds = '00' // 秒

    if (times <= 9) {
        seconds = formateNums(times)
        minutes = '00'
    } else if (times > 9 && times < 60) {
        seconds = times
        minutes = '00'
    } else if (times >= 60) {
        minutes = formateNums(Math.floor(times / 60))
        seconds = formateNums(times % 60)
    } else {
        minutes = '00'
        seconds = '00'
    }
    return minutes + ':' + seconds
}
